import React, { useState, useEffect } from "react";
import ExpenseOpeningBalanceController from '../Controllers/ExpenseOpeningBalanceController';
import LoadingSkeleton from "../../Components/LoadingSkeleton";
import Input from "../../Components/Input";
import Loader from "../../Components/Loader";

const ExpenseOpeningBalanceScreen = ({ expenseOpeningInfo, expenseOpeningInfoLoading, expenseOpeningInfoError, onRefresh }) => {
    console.log('screen expenseOpeningInfo', expenseOpeningInfo?.exp_open_balance);
    const { expenseSettingsData,
        expenseOpeningBal, setExpenseOpeningBal,
        expenseOpeningBalError,
        openingBalanceAddLoading,
        openingBalanceAddError,
        openingBalanceAddSuccess,
        isEditing,
        setIsEditing,
        handleInputChange,
        handleAddOpeningBalance
    } = ExpenseOpeningBalanceController(expenseOpeningInfo, onRefresh, expenseOpeningInfoError);

    console.log('expenseSettingsData', expenseSettingsData)

    return (
        <div style={styles.container}>
            <h2 style={{ ...styles.title, ...(isEditing ? { marginBottom: '10px' } : {}) }}>Expense Management Opening Balance</h2>

            <div style={{ ...styles.field, ...(isEditing ? { marginBottom: '0px', marginTop: '0px' } : {}) }}>
                <label style={styles.label}>Books Opening Balance</label>
                {isEditing  ? (
                    <>{expenseOpeningInfoLoading ? (<LoadingSkeleton width="100px" height="15px" />) : 
                    <Input
                        value={expenseSettingsData?.exp_open_balance || ''}
                        onChange={(e) => handleInputChange(e.target.value)}
                        errorMessage={expenseOpeningBalError}
                        inputType='number'
                        placeholder=""
                    />
                }</>

                ) : (
                    <span style={styles.value}>{expenseOpeningInfoLoading ? (<LoadingSkeleton width="100px" height="15px" />) : (<span>{expenseSettingsData?.exp_open_balance == null ? '--' : expenseSettingsData?.exp_open_balance}</span>)}</span>
                )}
            </div>
            <div className="button-container" style={{ gap: "10px" }}>
                {isEditing &&<button className="add-client-button"
                    style={{
                        ...styles.updateButton, paddingLeft: 30, paddingRight: 30, opacity: openingBalanceAddLoading || expenseOpeningInfoLoading || openingBalanceAddSuccess ? 0.5 : 1, // Reduce opacity when loading
                        cursor: openingBalanceAddLoading || expenseOpeningInfoLoading || openingBalanceAddSuccess ? 'not-allowed' : 'pointer', gap: '10px',
                    }} onClick={handleAddOpeningBalance} disabled={openingBalanceAddLoading || expenseOpeningInfoLoading || openingBalanceAddSuccess}>
                    <span>Add</span>
                    {(openingBalanceAddLoading || expenseOpeningInfoLoading) && (
                        <Loader loading={openingBalanceAddLoading || expenseOpeningInfoLoading} color={'var(--background-color)'} size="small" />
                    )}</button>}
                {openingBalanceAddSuccess && <div className="list-success-msg">{openingBalanceAddSuccess} </div>}
                {openingBalanceAddError && <div className="list-error-msg">{openingBalanceAddError} </div>}
                
            </div>
        </div>
    )
}

const styles = {
    title: {
        color: 'black',
        fontSize: 18,
        fontFamily: 'Roboto',
        fontWeight: '500',
    },
    field: {
        display: "flex",
        alignItems: "center",
        marginBottom: "25px",
        marginTop: "25px",
    },
    label: {
        flex: "0 0 200px",
        color: 'black',
        fontSize: '14px',
        fontFamily: 'Roboto',
        fontWeight: '400',
    },
}

export default ExpenseOpeningBalanceScreen;